// 将接口返回的处理失败的excel行字符串数据中的用户角色转换成整数展示
// 接口会返回成浮点数
export const convertRoleIDToInt = (content: string) => {
  const data = content.split(',');

  return [...data.slice(0, data.length - 1), parseInt(data[data.length - 1])].join(',');
};
